<template>
  <div class="app-order-options accordion-inner">
    <slot name="txtBefore"></slot>
    <slot name="txtBeforeTariff"></slot>
    <b-form
      class="checkout-top-up-form"
      :id="'form' + _uid"
      :novalidate="true"
    >
      <slot name="txtBeforeTopUp"></slot>
      <checkout-auto-single-top-up-wrapper
        :selected-top-up-types.sync="selectedTopUpTypes"
        :autoTopUp.sync="autoTopUp"
        :singleTopUp.sync="singleTopUp"
        :topUpAmounts="topUpAmounts"
      >
        <template v-for="slot in possibleChildSlotsFor('TopUp')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </checkout-auto-single-top-up-wrapper>
    </b-form>
    <div class="order-step">
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="save" class="btn-next" type="button" variant="primary">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import CheckoutAutoSingleTopUpWrapper
  from '@/components/process/generic/Checkout/otelo/CheckoutTopUpWrapper.vue'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import preFilledInput from '@/mixins/preFilledInput'

export const stepName = 'options'
export default {
  name: 'Options',
  data () {
    return {
      loading: false
    }
  },
  components: {
    BButton, CheckoutAutoSingleTopUpWrapper
  },
  computed: {
    ...mapGetters('orderProduct/topUp', {
      storedAutoTopUp: 'topUp',
      storedSingleTopUp: 'singleTopUpAmount',
      storedSelectedTopUpTypes: 'selectedTopUpTypes'
    }),
    defaultSelectedTopUpTypes: function () {
      if (this.storedSelectedTopUpTypes.length === 0) {
        return [
          'without'
        ]
      }
      return this.storedSelectedTopUpTypes
    }
  },
  methods: {
    async save () {
      this.loading = true
      this.storeSelection(this.selectedTopUpTypes)
      this.storeAutoTopUpData(this.autoTopUp)
      this.storeSingleTopUpData(this.singleTopUp)
      this.commitOptions({ options: true })
      this.changeStep({ step: this.nextStep })
      this.loading = false
    },
    ...mapMutations('orderProduct', {
      changeStep: 'changeStep',
      commitOptions: 'commitOptions'
    }),
    ...mapMutations('orderProduct/topUp', {
      storeSelection: 'storeSelection',
      storeAutoTopUpData: 'storeAutoTopUpData',
      storeSingleTopUpData: 'storeSingleTopUpData'
    })
  },
  props: {
    nextStep: {
      type: String,
      default: 'personalData'
    },
    topUpAmounts: {
      type: Object,
      default: null
    }
  },
  mixins: [
    transaction('orderOptions'),
    preFilledObjectInput('autoTopUp', 'storedAutoTopUp'),
    preFilledInput('singleTopUp', 'storedSingleTopUp'),
    preFilledInput('selectedTopUpTypes', 'defaultSelectedTopUpTypes'),
    slotProxy()
  ]
}
</script>
